/**
 * Форматирует полное имя: «Фамилия Имя Отчество».
 * Пропускает пустые части.
 */
export function formatFullName(
  familyName?: string | null,
  givenName?: string | null,
  patronymic?: string | null,
): string {
  const parts = [familyName, givenName, patronymic].filter(
    (p): p is string => typeof p === 'string' && p.trim().length > 0,
  );
  return parts.join(' ') || '';
}
